export const LOAD_MY_BIZ_API = 'LOAD_MY_BIZ_API';
export const SET_MY_BIZ_API='SET_MY_BIZ_API';

export const LOAD_TALLY_INFO_API = "LOAD_TALLY_INFO_API";
export const SAVE_TALLY_INFO = "SAVE_TALLY_INFO"